<template>
  <v-container fluid class="pa-0 pt-5 mt-2">
    <!--modal-->
    <UploadFilesRFQ
      :operationList="operationList"
      :rfqId="rfqId"
      v-model="openUpload"
      :id="operationId"
      :master-email="masterEmail"
      :broker-email="brokerEmail"
      :operation-details="operationDetails"
      @operationInfo="handleOperationName"
    />

    <selectClient v-model="filesUpload" :clients="clients" 
      @operation-details-submitted="handleOperationDetailsSubmitted" />

    <!--list-->
    <v-footer color="transparent d-flex align-center justify-center">
      <v-col class="ma-0 pa-0" cols="12">
        <v-sheet width="100%" class="py-2">
          <v-row no-gutters>
            <v-col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              style="gap: 0.6rem"
              class="pt-1 d-flex flex-column"
            >
              <div
                style="width: 100%"
                class="d-flex flex-row justify-space-between mb-5"
              >
                <div class="text-body-2 font-weight-light">
                  {{ $t("menus.registeredOperations") }}
                </div>
                <div class="d-flex flex-row align-center flex-gap-2 flex-nowrap justify-end">
                  <v-btn
                    outlined
                    x-small
                    @click="downloadOperation()"
                    :disabled="enableDownlaodBasedOnCheckBox || loading"
                    :loading="loading"
                  >
                    {{ $t("console.tlsSummary.certificates.download") }}</v-btn
                  >
                  <v-btn
                    x-small
                    color="primary"
                    data-testid="desk-new-operation"
                    @click="openUploadModal(null)"
                    >{{ $t("instructions.new") }}</v-btn
                  >
                </div>
              </div>

              <v-card
                v-show="allOperations.length > 0"
                :style="
                    checkbox[op.id]
                    ? 'border: 1px solid #0073ff; background : #0B2D54'
                    : ''
                "
                class="d-flex flex-column align-start pa-1"
                outlined
                :key="`${op.id}-${idx}`"
                v-for="(op, idx) in allOperations"
              >

                <div class="flex-grow-1 card-content">
                  <div class="d-flex flex-row align-center justify-space-between"  style="grid-column: 1 / -1;">                   
                      <div style="width:100%" class="d-flex flex-wrap align-center flex-gap-1 justify-space-between">
                          <div class="mx-2">
                      <v-tooltip bottom v-if="partners[op.brokerId]">
                          <template v-slot:activator="{on, attrs}">
                            <v-chip
                              v-on="on"
                              v-bind="attrs" 
                              class="py-2 ma-2 partner-chip"
                               x-small>
                                  <span class="text-center short-id" color="white">{{partners[op.brokerId]}}</span>
                            </v-chip>
                            </template>
                            {{partners[op.brokerId]}}
                      </v-tooltip>
                    </div>                    
                      <div class="text-caption text-no-wrap short-id" >
                        {{ operationTitles(op).id || ''}}
                      </div>
                      </div>
                    <v-btn
                      @click="inputOperation(op.id)"
                      :disabled="disableDeleteButton(op.id)"
                      small
                      icon
                      color="red"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                    </div>   
                  
                  <div
                    class="d-flex flex-column align-center"
                    style="grid-column: 1 / -1"
                  >
                    <v-card-title
                      style="padding: 0 !important"
                      class="text-body-2 font-weight-bold text-wrap mb-1 mx-3"
                    >
                      {{ operationTitles(op).alias }}
                    </v-card-title>
                  </div>
                  <v-divider class="mx-7 my-1" style="grid-column: 1/-1;"/>
                  <div class="d-flex flex-row align-center justify-space-between mx-5" style="grid-column: 1/-1;">
                  <div style="max-height:4vh" class="d-flex flex-row align-center justify-center">
                    <v-checkbox
                      dense
                      :disabled="op.length < 1"
                      @change="e=>handleChange(e, op.id)"
                      v-model="checkbox[op.id]"
                    />
                    <v-chip
                      outlined
                      x-small
                      class="d-flex align-center justify-center py-2  mt-1"
                      :color="amlCheck(op)"
                    > 
                        <v-btn x-small class="py-4 px-0 ma-0" :style="{cursor: userRole === 'partner' || op.amlCheck ? 'default' : 'pointer' }" text
                          data-testid="operation-aml" :data-operation-id="op.id"
                          @click="amlModalOpen(op)">
                          <v-icon class="mr-2" :color="amlCheck(op)" x-small>{{
                              !op.amlCheck ? "mdi-alert" : "mdi-check"
                            }} </v-icon>
                          <span style="font-size:.6rem !important" :style="{color:amlCheck(op)}">{{ !op.amlCheck ? $t('instructions.amlCheck') :  $t('instructions.amlApproved') }}</span>
                        </v-btn>
                    </v-chip>
                  </div>

                  <div class="d-flex flex-column align-center mb-1">
                    <div>
                      <p class="text-body-2 pa-0 ma-0">
                        <span
                          :style="
                            op.side === 'BUY'
                              ? 'color:#00c853'
                              : op.side === 'SELL' ?
                               'color:#ff6d00;' :
                               'color: white'
                          "
                          >{{ operationTitles(op).side }}&nbsp;</span>
                        <v-chip 
                        class="px-2 mb-1"
                        :color="op.status === 'DEAL' ? 
                          '#00c853' : 
                          op.status === 'CANCELLED' ? 
                          '#ff6d00': 
                          '#727272'"
                        v-show="op.status" 
                        x-small outlined>{{ operationTitles(op).status}}</v-chip>
                        
                      </p>
                      <div style="letter-spacing: .05rem;" class="d-flex mt-1 flex-row align-end justify-center flex-no-wrap">
                        <h6 class="py-1">{{operationTitles(op).ccy }}</h6>
                        <h4 class="font-weight-bold">
                          &nbsp;{{ operationTitles(op).qty }}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      <h6 class="text-caption">
                        {{ $t("broker.labels.companyName") }}
                      </h6>
                      <h6 class="font-weight-bold">{{op.companyName}}</h6>
                    </div>
                  </div>
                  </div>
                </div>
              </v-card>
              <div v-show="allOperations.length === 0" >
                <h4 class="text-center mt-8 text--secondary font-weight-light">No Operations found.</h4>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-pagination
        v-if="operationPagination.length"
        v-model="currentPerPage"
        :length="
          Math.max(1, Math.ceil(operationPagination.length / activeOperationPerPage))
        "
        class="mx-auto pagi-small mt-5"
        circle
        color="primary"
      />
    </v-footer>

  <delete-modal
    v-model="inputDialog"
    :item-label="deleteOperationLabel"
    @confirm="confirmDeleteOperation"
  />

    <!-- AML MODAL -->
    <aml-modal v-model="aml" :selected-op="selectedOp" :master-email="masterEmail" :broker-email="brokerEmail"/>
  </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useExecutionStore, useImportFiles } from "../../store/index";
import UploadFilesRFQ from "@/components/modal/UploadFilesRFQ.vue";
import selectClient from "@/components/modal/selectClient.vue";
import AmlModal from "@/components//modal/AmlModal.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";

export default {
  props: {
    list: {
      required: true,
      default: () => []
    },
    clients: {type: Array, default: () => []},
    masterEmail:{type: String, default: ''},
    brokerEmail:{type: String, default: ''}
  },
  watch: {
list: {
  immediate: true,
  deep: true,
  handler: async function (newVal) {
    try {
      if (!Array.isArray(newVal) || newVal.length === 0) return;

        this.operationList = newVal;
        this.rfqId = newVal[0]?.rfqId || "";

        if (this.userRole === "broker") {
          const brokerIds = [...new Set(newVal.map(op => op.brokerId).filter(Boolean))];

          const brokerResults = await Promise.allSettled(
            brokerIds.map(id => this.executionStore.getBrokerById(id))
          );
          brokerResults.forEach((r, idx) => {
            const brokerId = brokerIds[idx];

            if (r.status === "fulfilled") {
              const b = r.value.data;
              const partnerName = b?.partmaster_id !== 0 ? (b?.name || "") : "";
              this.$set(this.partners, brokerId, partnerName);
            } else {
              const status = r.reason?.response?.status;
              if (status !== 404) console.log("getBrokerById failed:", r.reason);
              this.$set(this.partners, brokerId, "");
            }
          });
        }

        const companyIds = [...new Set(newVal.map(op => op.companyId).filter(Boolean))];

        const companyResults = await Promise.allSettled(
          companyIds.map(id => this.executionStore.getCompanyById(id))
        );

        const companyNameById = {};
        companyResults.forEach((r, idx) => {
          const companyId = companyIds[idx];

          if (r.status === "fulfilled") {
            companyNameById[companyId] = r.value.data?.name || "-";
          } else {
            const status = r.reason?.response?.status;
            if (status !== 404) console.log("getCompanyById failed:", r.reason);
            companyNameById[companyId] = "-";
          }
        });

        this.operationListWithName = newVal.map(op => ({
          ...op,
          companyName: companyNameById[op.companyId] || "-",
        }));

      } catch (err) {
        console.log("list watcher failed:", err);
      }
    },
  },
  },
  components: { AmlModal, UploadFilesRFQ, selectClient, DeleteModal },
  mounted() {
    this.executionStore.selectedId = null;
    // this.operationList = JSON.parse(localStorage.getItem("operation") || "[]");
    // this.rfqId = this.operationList.rfqId || "";
  },
  data() {
    return {
      loading: false,
      aml:false,
      clientId: null,
      openUpload: false,
      doctype:[
        "invoice",
        "import_declaration",
        "proof_of_import",
        "bill_of_lading"
      ],
      selectedOp: {},
      operationDetails:{},
      operationListWithName:[],
      checkbox: {},
      operationList: [],
      currentPerPage: 1,
      activeOperationPerPage: 2,
      alias: "",
      rfqId: null,
      files: "",
      operationId: undefined,
      opIds: [],
      listDocuments: [],
      wasFilesUploaded: false,
      filesUpload: false,
      inputDialog : false,
      deleteId: null,
      clientRemessaType: null,
      partners:{},
      userRole: localStorage.getItem('userRole')
    };
  },
  computed: {
    ...mapStores(useExecutionStore),
    deleteOperationLabel () {
      const operation = this.operationList.find(item => item.id === this.deleteId)
      return operation?.alias || ''
    },
    enableDownlaodBasedOnCheckBox() {
      return Object.values(this.checkbox).every((v) => !v);
    },
    operationHeaders() {
      return [
        { text: this.$t(""), value: "documents", sortable: false },
        { text: "ALIAS", value: "alias", sortable: false },

        { text: this.$t("quoteInfo.id"), value: "rfq_id", sortable: false },
        {
          text: this.$t("quoteInfo.dealTime"),
          value: "rfq_deal_time",
          sortable: false,
        },
        // { text: 'Status', value: 'rfq_deal', sortable: false },
        { text: this.$t("quoteInfo.ccy"), value: "rfq_ccy", sortable: false },
        { text: this.$t("quoteInfo.side"), value: "rfq_side", sortable: false },
        {
          text: this.$t("quoteInfo.amount"),
          value: "rfq_amount",
          sortable: false,
        },
        {
          text: this.$t("quoteInfo.settlement"),
          value: "rfq_spotsett",
          sortable: false,
        },
        {
          text: this.$t("quoteInfo.maturityText"),
          value: "rfq_maturity",
          sortable: false,
        },
        {
          text: this.$t("quoteInfo.bankName"),
          value: "bank_label",
          sortable: false,
        },

        { text: this.$t(""), value: "edit", sortable: false },
        { text: this.$t(""), value: "delete", sortable: false },
      ];
    },
    operationElements() {
      return [
        {
          id: 0,
          alias: this.alias,
          rfq_ccy: 0,
          rfq_amount: 0,
          rfq_spotsett: 0,
          rfq_deal_time: 0,
          rfq_security: "FXSPOT",
          rfq_maturity: "",
          documents:
            this.operationId !== undefined || this.operationId !== null,
        },
      ];
    },
    operationPagination(){
      return this.operationList.filter(op=>op.rfqId === null)
    },
    allOperations() {
      const per = this.activeOperationPerPage || 2;
      const total = this.operationListWithName.length;
      const totalPages = Math.max(1, Math.ceil(total / per));
      const page = Math.min(Math.max(this.currentPerPage || 1, 1), totalPages);

      const start = (page - 1) * per;
      const end = start + per;
      const filtered = this.operationListWithName.filter(op=>op.rfqId === null)
      return filtered.slice(start, start + per);
    },
  },
  methods: {
    handleChange(e, id)
    {
      const idx = this.opIds.indexOf(id)
     if(e === true)
      {
        if(idx === -1 )
          {
            this.opIds.push(id)
          }
      }
      else{
        if(idx !== -1)
          {
            this.opIds.splice(idx, 1)
          }
      }
    },
    amlModalOpen(op){
      this.selectedOp = op;
      this.aml = true
    },
    amlCheck(op) {
      return op.amlCheck ? '#00c853' :'#ff6d00'
    },
    async downloadOperation() {
      this.loading = true
     // const operationIds = Object.keys(this.checkbox || {})
      const doctypes = this.doctype || []

      if (!this.opIds.length || !doctypes.length) return
      for (const operationId of this.opIds) {
        const client = this.allOperations.find(op=>op.id === operationId)
        const name = client?.companyName
        const partner = this.partners[client.brokerId] ? true : false
        const zipStore = useImportFiles()
       await zipStore.downloadFiles('operation', operationId,name, partner)
       this.loading=false
       this.$emit("downloaded", true)

      }
    },
    disableDeleteButton(id){
      let hasRfq = this.operationList.find(op => op.id === id)?.rfqId
      return hasRfq !== null;
    },
    operationTitles(op){
      return {
        opDocLength: op.length >= 4 ? true : false,
        id: 'ID ' + op.id,
        rfqId : op.rfqId ? 'RFQ ID ' +  op.rfqId : '' ,
        ccy:  op.ccy ? op.ccy : '', 
        side: op.side ? op.side : '',
        qty:op.qty ? op.qty :  '',
        status:op.status ? op.status : '',
        alias: op.alias 
      }
    },
    handleOperationName(e) {
      this.alias = e.alias;

      // if (this.alias !== "") {
      //   const ope = {
      //     id: this.operationId.toString(),
      //     rfqId: "",
      //     alias: this.alias.toString(),
      //     length: Number(e.docs) || 0,
      //   };
      //   let arr = JSON.parse(localStorage.getItem("operation")) || [];
      //   arr = arr.filter((a) => a.id !== ope.id);
      //   arr.push(ope);
      //   localStorage.setItem("operation", JSON.stringify(arr));

      //   // this.operationList = JSON.parse(
      //   //   localStorage.getItem("operation") || "[]"
      //   // );
      // }
    },
    handleOperationDetailsSubmitted(e) {
      this.operationDetails={...e}
      this.openUpload = true
    },
    inputOperation(id) {
      this.inputDialog = true
      this.deleteId = id
    },
    confirmDeleteOperation () {
      if (this.deleteId === null) return
      this.$emit("delOperation", this.deleteId)
      this.inputDialog = false
      this.deleteId = null
    },
    openUploadModal(id) {
      this.operationId =
        id !== null
          ? id
          : (Math.floor(Math.random() * (1000 - 1 + 1)) + 1).toString();
      // const selectedId = id !== true && id !== false ? id : null;
      // this.executionStore.setSelectedId(selectedId);
      this.filesUpload = true;
      this.showQuoteConfirmationDialog = false;
    },
  },
};
</script>

<style scoped>
::v-deep(.v-input__control) {
  padding-top: 1rem !important;
}
.card-content {
  display: grid;
  text-align: center;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 0.3rem;
  justify-content: space-between;
}
.text-caption {
  font-size: 0.55rem !important;
  line-height: 0.8rem;
  right:0;
}
.pagi-small{
  transform: scale(.7) !important;
  transform-origin: center!important;
}
.short-id {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
}
</style>

